import { ALL_CITIES } from "@/data/site";

export const slugify = (s) =>
  s
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

export const CITY_LIST = ALL_CITIES.map((name) => ({ name, slug: slugify(name) }));

export const getCity = (slug) => CITY_LIST.find((c) => c.slug === slug);
